import React from 'react';
import { connect, MapDispatchToProps } from 'react-redux';
import { NumberOrNull } from 'store/entity/types';
import { display } from 'components/ErrorView/ErrorDialog';
import TaskConversation from 'containers/Tasks/Conversation/TaskConversation';
import { ChatBodyContainer } from './styles';
import { TaskOptionsIcon } from '../../../components/TaskEditorHeader/styles';
import { navigate } from '@reach/router';
import { appDispatch } from 'store/store';
import { markAsRead, markAsReadFn } from 'store/messages/messagesSlice';
import {
  loadOlderMessages,
  loadOlderMessagesFn,
} from 'store/conversation/conversationSlice';
import i18n from '../../../i18n';

interface IDispatchToProps {
  markAsRead: (conversationId: number) => ReturnType<typeof markAsReadFn>;
  loadOlderMessages: (
    conversationId: number,
    count?: number
  ) => ReturnType<typeof loadOlderMessagesFn>;
}

interface IOwnProps {
  selectedChat: NumberOrNull;
}

interface IComponentState {
  loading: boolean;
}

type IComponentProps = IOwnProps & IDispatchToProps;

class ChatBody extends React.Component<IComponentProps, IComponentState> {
  state: IComponentState = {
    loading: true,
  };

  handleClose = () => {
    navigate('.');
  };
  componentDidMount() {
    if (this.props.selectedChat) {
      this.props.loadOlderMessages(this.props.selectedChat).then(
        () => {
          this.setState({ loading: false });
          if (this.props.selectedChat) {
            this.props.markAsRead(this.props.selectedChat);
          }
        },
        (err: any) => {
          display(err);
        }
      );
    }
  }

  componentDidUpdate(prevProps: IComponentProps) {
    const { selectedChat } = this.props;
    if (selectedChat && prevProps.selectedChat !== selectedChat) {
      this.setState({ loading: true });
      this.props.loadOlderMessages(selectedChat).then(
        () => {
          this.setState({ loading: false });
          this.props.markAsRead(selectedChat);
        },
        (err: any) => {
          display(err);
        }
      );
    }
  }

  render() {
    const { selectedChat } = this.props;
    return (
      <ChatBodyContainer hideOnSmall={!selectedChat}>
        {selectedChat ? (
          <>
            <TaskConversation conversationId={selectedChat} />
            <TaskOptionsIcon
              style={{ position: 'absolute', top: '17px', left: '10px' }}
              type="x"
              title={i18n.t('close', { ns: 'dialects' }) as string}
              onClick={this.handleClose}
            />
          </>
        ) : (
          <div
            className="center-vh"
            style={{ margin: '1em 0', flex: '1', alignItems: 'center' }}
          >
            <span>
              {i18n.t('pleaseSelectAChat', { ns: 'dialects' }) as string}
            </span>
          </div>
        )}
      </ChatBodyContainer>
    );
  }
}

const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  IOwnProps
> = () => {
  return {
    markAsRead: (conversationId: number) =>
      appDispatch(markAsRead({ conversationId })),
    loadOlderMessages: (conversationId: number, count?: number) =>
      appDispatch(loadOlderMessages({ conversationId, count })),
  };
};

export default connect(null, mapDispatchToProps)(ChatBody);
